var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file 标签
 * @author (zhanghao14)
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'lodash-es';

import { noop, classPrefix } from '../../common/util';

import './Tag.less';

/**
 * 参数说明
 * className         可选，自定义样式类名
 * classPrefix       可选，类名前缀
 * closable          可选，是否显示icon
 * isShow            可选，是否显示
 * title             可选，tag上显示的内容
 * onClick           可选，icon被点击时触发
 * data              可选，储存在组件的数据，点击close时作为第二入参
 * disable           可选，禁用状态
 * type              可选，与color属性同时作用，可选值：pure、lightPure、hollow
 * color             可选，与type属性同时作用，可选值：red、orange、yellow、green、blue、purple
 */

var Tag = function (_Component) {
    _inherits(Tag, _Component);

    function Tag() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Tag);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Tag.__proto__ || Object.getPrototypeOf(Tag)).call.apply(_ref, [this].concat(args))), _this), _this.closeOnClick = function (e) {
            var _this$props = _this.props,
                closeOnClick = _this$props.closeOnClick,
                data = _this$props.data;

            _.isFunction(closeOnClick) && closeOnClick(e, data);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Tag, [{
        key: 'render',
        value: function render() {
            var _classnames;

            var _props = this.props,
                classPrefix = _props.classPrefix,
                closable = _props.closable,
                isShow = _props.isShow,
                title = _props.title,
                className = _props.className,
                disable = _props.disable,
                type = _props.type,
                color = _props.color,
                shape = _props.shape;

            var prefixCls = classPrefix + '-tag';
            var containerProps = {
                className: classnames((_classnames = {}, _defineProperty(_classnames, prefixCls, true), _defineProperty(_classnames, className, !!className), _defineProperty(_classnames, 'tag-disable', disable), _defineProperty(_classnames, type + '-' + color, !!(type && color)), _defineProperty(_classnames, prefixCls + '-' + shape, !!shape), _classnames))
            };
            var tagDivCls = classnames({
                'tag-div': true
            });
            var iconCls = classnames({
                'tag-icon': true
            });
            return isShow ? React.createElement(
                'div',
                containerProps,
                React.createElement(
                    'div',
                    { className: tagDivCls },
                    title,
                    closable && React.createElement('div', { className: iconCls, onClick: this.closeOnClick })
                )
            ) : null;
        }
    }]);

    return Tag;
}(Component);

export default Tag;


Tag.defaultProps = {
    // base
    className: '',
    classPrefix: classPrefix,
    // self
    closable: false,
    isShow: true,
    title: '',
    shape: '',
    closeOnClick: noop,
    disable: false
};

Tag.propTypes = {
    className: PropTypes.string,
    classPrefix: PropTypes.string,
    closable: PropTypes.bool,
    isShow: PropTypes.bool,
    title: PropTypes.string.isRequired,
    closeOnClick: PropTypes.func,
    data: PropTypes.any,
    disable: PropTypes.bool,
    type: PropTypes.string,
    shape: PropTypes.string,
    color: PropTypes.string
};